import { connect } from 'react-redux';

const InventoryIndex = require('../components/management/Inventory');

const Index = connect()(InventoryIndex);

module.exports = Index;


/** WEBPACK FOOTER **
 ** ./src/containers/Inventory.js
 **/